export default __webpack_public_path__ + "static/media/24t.aeb3fc99.jpg";